import { Grid } from "@mui/material";

import ConnectionsByMonthCard from "./ConnectionsByMonthChart/ConnectionsByMonthCard";
import ConnectionsEntitiesPanel from "./ConnectionsEntitiesPanel/ConnectionsEntitiesPanel";
import ConnectionsPeriodCard from "./ConnectionsPeriodChart/ConnectionsPeriodCard";
import ConnectionsStatusChart from "./ConnectionsStatusChart/ConnectionsStatusChart";
import Context from "./context";
import StatisticsGrid from "./StatisticsGrid";

// ----------------------------------------------------------------------

type Props = {
	product?: string;
};

export const AnalyticsPanel = ({ product }: Props) => {
	return (
		<Context.Provider value={{ product }}>
			<StatisticsGrid />
			<Grid container spacing={3} sx={{ mt: 1 }}>
				<Grid item xs={12} lg={8}>
					<ConnectionsPeriodCard />
				</Grid>
				<Grid item xs={12} lg={4}>
					<ConnectionsStatusChart />
				</Grid>
				<Grid item xs={12} lg={7}>
					<ConnectionsByMonthCard />
				</Grid>
				<Grid item xs={12} lg={5}>
					<ConnectionsEntitiesPanel />
				</Grid>
			</Grid>
		</Context.Provider>
	);
};

export default AnalyticsPanel;
